import { SelectString } from '@components/SelectString'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import type { Discipline } from '../../../core/util/discipline'
import {
  alDisciplineOptions,
  disciplineLabels,
  hlDisciplineOptions,
} from '../../../core/util/discipline'

export { SelectDisciplines }

type Props = {
  projectType: Projectbetrokkene['projectType']
  value: Discipline[]
  onChange: (value: Discipline[]) => void
  errorText?: string
}

/** Warmte (H) is voor Aanvraag nog niet aangeboden, de api accepteert het wel */
const SelectDisciplines = ({
  projectType,
  value,
  onChange,
  errorText,
}: Props) => (
  <SelectString<Discipline>
    multiple
    disableClearable
    label="Disciplines"
    options={
      projectType === 'Aanvraag' ? alDisciplineOptions : hlDisciplineOptions
    }
    getOptionLabel={(discipline) => disciplineLabels[discipline]}
    value={value}
    onChange={onChange}
    error={!!errorText}
    helperText={errorText}
  />
)
